module.exports = __webpack_public_path__ + "img/logo.2b39dca5.png";